import { useMemo } from 'react'
import {
    jornada,
    JornadaDiariaQueryXor,
    JornadaMensalQueryXor,
} from 'service/api'
import { useStore } from 'store'
import { diarioColumns, mensalColumns } from '../columns'
import TodosToolbar from '../toolbar/todos-toolbar'
import { DigitacaoSubPages } from './DigitacaoSubPages'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoTodosPage() {
    const { view, queryParams } = useDigitacaoContext()
    const empresa = useStore(state => state.company)

    const {
        data: mensal,
        isFetching: isLoadingMensal,
        error: mensalError,
        isError: isErrorMensal,
    } = jornada.mensal.useFetch({
        queryParams: queryParams as JornadaMensalQueryXor,
        enabled: !('dia' in queryParams) && !!queryParams.funcionarioId,
    })

    const {
        data: diario,
        isFetching: isLoadingDiario,
        error: diarioError,
        isError: isErrorDiario,
    } = jornada.diaria.useFetch({
        queryParams: queryParams as JornadaDiariaQueryXor,
        enabled: 'dia' in queryParams && !!queryParams.empresaId,
    })

    const columns = useMemo(
        () =>
            view === 'mensal'
                ? mensalColumns(empresa?.exibirSaldoDiario == 'S')
                : diarioColumns,
        [view, empresa?.exibirSaldoDiario],
    )

    return (
        <DigitacaoSubPages
            Toolbar={TodosToolbar}
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={diarioError}
            mensalError={mensalError}
            isErrorDiario={isErrorDiario}
            isErrorMensal={isErrorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
